<div class="help-view p-3 p-md-4 text-white">
    <!-- Header Section -->
    <div class="help-header mb-4 text-center text-md-start d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
        <div>
            <h2 class="fw-bold mb-1 d-flex align-items-center justify-content-center justify-content-md-start gap-2">
                <i class="bi bi-question-circle-fill text-danger"></i>
                Help & Frequently Asked Questions
            </h2>
            <p class="text-muted mb-0">Find quick answers, guides, and video tutorials for Rival Forge.</p>
        </div>

        <!-- Search Bar -->
        <div class="search-box position-relative" style="min-width: 280px;">
            <i class="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary"></i>
            <input type="text" class="form-control bg-dark text-white border-secondary ps-5 rounded-pill shadow-sm"
                placeholder="Search questions or keywords..." [ngModel]="searchQuery()" (ngModelChange)="searchQuery.set($event)">
        </div>
    </div>

    <!-- Category Filters -->
    <div class="category-tabs d-flex flex-wrap gap-2 mb-4">
        @for(cat of categories(); track cat) {
        <button class="btn rounded-pill px-3 py-1 text-nowrap transition-all"
            [class.btn-danger]="selectedCategory() === cat"
            [class.btn-outline-secondary]="selectedCategory() !== cat"
            (click)="selectCategory(cat)">
            {{ cat }}
        </button>
        }
    </div>

    <!-- FAQ Accordion List -->
    <div class="faq-accordion-container">
        @if(filteredFaqs().length === 0) {
        <div class="text-center p-5 bg-dark bg-opacity-50 rounded-3 border border-secondary">
            <i class="bi bi-search fs-1 text-secondary mb-3 d-block"></i>
            <h5 class="fw-bold mb-1">No matching questions found</h5>
            <p class="text-muted small mb-0">Try adjusting your search filter or category selection.</p>
        </div>
        }

        <div class="d-flex flex-column gap-3">
            @for(item of filteredFaqs(); track item.id) {
            <div class="faq-item-card rounded-3 border transition-all overflow-hidden"
                [class.border-danger]="item.expanded"
                [class.border-secondary]="!item.expanded"
                style="background-color: #12141a;">

                <!-- Accordion Header -->
                <div class="faq-header p-3 p-md-4 d-flex align-items-center justify-content-between cursor-pointer user-select-none"
                    (click)="toggleFaq(item)">
                    <div class="d-flex align-items-center gap-3 pe-3">
                        <span class="badge bg-secondary bg-opacity-25 text-danger border border-danger border-opacity-25 rounded-pill px-2.5 py-1">
                            {{ item.category }}
                        </span>
                        <h5 class="fw-bold mb-0 text-white fs-6 fs-md-5">{{ item.question }}</h5>
                    </div>
                    <button class="btn btn-sm btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                        style="width: 32px; height: 32px;">
                        <i class="bi" [class.bi-chevron-up]="item.expanded" [class.bi-chevron-down]="!item.expanded"></i>
                    </button>
                </div>

                <!-- Accordion Body -->
                @if(item.expanded) {
                <div class="faq-body px-3 px-md-4 pb-4 border-top border-secondary border-opacity-25 pt-3">
                    <p class="text-white-50 mb-3 leading-relaxed" style="font-size: 0.95rem;">
                        {{ item.answer }}
                    </p>

                    <!-- YouTube Embedded Video -->
                    @if(item.safeVideoUrl) {
                    <div class="video-embed-wrapper mt-3 rounded-3 overflow-hidden border border-secondary shadow-lg">
                        <div class="ratio ratio-16x9">
                            <iframe [src]="item.safeVideoUrl"
                                title="YouTube video player"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowfullscreen>
                            </iframe>
                        </div>
                    </div>
                    }
                </div>
                }
            </div>
            }
        </div>
    </div>
</div>
